<template>
  <section class="cards">
    <transition name="slideBurger">
      <app-contract-modal
          v-if="modal"
          @close="modal = false; scrollLock()">
      </app-contract-modal>
    </transition>
    <div class="card" :key="0">
      <h2 class="cardTitle"> Замена </h2>
      <router-link to="/change/changeInformation"> <img src="../img/zamena.webp" alt="замена"> </router-link>
    </div>
    <div class="card" :key="1">
      <h2 class="cardTitle"> Монтаж </h2>
      <router-link to="/montage/copperPipe"> <img src="../img/montage.webp" alt="монтаж"> </router-link>
    </div>
    <div class="card" :key="2">
      <h2 class="cardTitle"> Ремонт </h2>
      <router-link to="/repair/repairBoiler"> <img src="../img/repair.webp" alt="ремонт"> </router-link>
    </div>
    <div class="card" :key="3">
      <h2 class="cardTitle"> диагностирование </h2>
      <router-link to="/control"> <img src="../img/control.webp" alt="диагностирование"> </router-link>
    </div>
    <div class="card" :key="4">
      <h2 class="cardTitle"> Сервис-ТО </h2>
      <router-link to="/service/serviceInformation"> <img src="../img/service.webp" alt="сервис"> </router-link>
    </div>
    <div class="card" :key="5">
      <h2 class="cardTitle"> Защита от СО </h2>
      <router-link to="/protection"> <img src="../img/protect.webp" alt="защита от угарного газа"> </router-link>
    </div>
    <div class="card" :key="6">
      <h2 class="cardTitle"> Документы </h2>
      <router-link to="/documents"> <img src="../img/docs.webp" alt="документы"> </router-link>
    </div>
    <div class="card" :key="7">
      <h2 class="cardTitle"> F.A.Q. </h2>
      <router-link to="/questions"> <img src="../img/question.webp" alt="вопросы"> </router-link>
    </div>
    <div class="card" :key="8">
      <h2 class="cardTitle">Заключить Договор</h2>
      <router-link to="#"> <img @click="modal = true; scrollLock()" src="../img/contract.png" alt="заключить договор"> </router-link>
    </div>
  </section>
</template>

<script>
import AppContractModal from "@/components/AppContractModal";
import {ref} from "vue";

  export default {
    components: {AppContractModal},

    setup() {
      let modal = ref(false)

      function scrollLock() {
        if (modal.value === true) {
          document.body.style.overflow = "hidden"
        } else {
          document.body.style.overflow = ""
        }
      }

      return {
        modal,
        scrollLock
      }
    }

  }

</script>

<style scoped>

 .slideBurger-enter-from {
   opacity: 0;
 }
 .slideBurger-leave-to {
   opacity: 0;
 }
 .slideBurger-enter-active, .slideBurger-leave-active {
   transition: all 1s;
 }

 section {
   display: flex;
   flex-wrap: wrap;
   justify-content: space-around;
   align-items: center;
   background-color: bisque;
   padding: 30px;
 }

 h2 {
   margin: 10px;
 }

 .card {
   background: linear-gradient(45deg, rgba(80,114,249,1) 0%, rgba(199,226,241,1) 63%);
   display: flex;
   text-align: center;
   flex-direction: column;
   height: auto;
   max-width: 500px;
   transition: all 100ms ease-in-out;
   border-radius: 50px;
   margin: 15px;
 }

 .card:hover {
   box-shadow: 0 0 6px 10px #ffa62f;
 }

 .cardTitle{
   font-size: 2.5em;
   display: inline-block;
   font-weight: 700;
   text-align: center;
   border-bottom-color: #111111;
 }

 img {
   width: 60%;
   height: auto;
   margin-right: auto;
   margin-left: auto;
 }

 @media (max-width: 900px) {

   .cards {
     padding: 10px 0;
   }

   .card {
     width: 40%;
     border-radius: 20px;
     margin: 10px;
   }

   .cardTitle {
     font-size: 1.5em;
   }
 }

 @media (max-width: 400px) {
    .cardTitle {
     font-size: 1em;
   }
 }

 @media (max-height: 600px) {
   .card {
     max-width: 400px;
   }

   img {
     max-width: 50%;
   }
 }
</style>